import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard  {
  constructor(private router: Router, private auth: AuthService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    // Use the current-user API as the authoritative role source — the same one
    // the header/admin menu uses (user.roles). The JWT does not reliably carry
    // roles, which caused the admin menu to show while this guard denied access.
    return this.auth.getCurrentUser().pipe(
      map(user => {
        const ok = this.hasAdminRole(user);
        if (!ok) {
          this.router.navigate(['/csv-list']);
        }
        return ok;
      }),
      catchError(() => {
        this.router.navigate(['/csv-list']);
        return of(false);
      })
    );
  }

  // Detect an ADMIN role robustly regardless of encoding: roles as an array or a
  // delimited string, case-insensitive, with an optional 'ROLE_' prefix, under
  // roles/role/authorities. Strict — only grants on a genuine admin role.
  private hasAdminRole(user: any): boolean {
    if (!user) {
      return false;
    }
    const claims = [user.roles, user.role, user.authorities];
    const roles = claims
      .flatMap(c => Array.isArray(c) ? c : (typeof c === 'string' ? c.split(/[,\s]+/) : []))
      .filter(Boolean)
      .map((r: any) => String(r).toUpperCase());

    return roles.some(r => r === 'ADMIN' || r === 'ROLE_ADMIN');
  }
}
